import { FC, PropsWithChildren, ReactNode } from 'react';
import { LinearGradientProps } from 'expo-linear-gradient';
import { consumeBackPress } from '../../../utils/session/backInterceptor';
import { observer } from 'mobx-react';

import { ContentFrame } from './ContentFrame';
import { useStores } from '../../../hooks/useStores';

interface ContentFrameTreeProps extends PropsWithChildren {
  handleExit?: () => void;
  title?: string;
  showProgressBar?: boolean;
  linearGradient?: LinearGradientProps;
  footer?: ReactNode;
}

const _ContentFrameTree: FC<ContentFrameTreeProps> = ({
  children,
  handleExit,
  title,
  showProgressBar = true,
  linearGradient,
  footer,
}) => {
  const { treeNav } = useStores();

  const handleOnPrevious = () => {
    console.log('--- ContentFrameTree handleOnPrevious ---');
    // a frame with inner stages (the challenge step) steps back inside first
    if (consumeBackPress()) {
      return;
    }
    if(treeNav.isStart) {
      handleExit?.();
    } else {
      treeNav.moveBack();
    }
  };

  return (
    <ContentFrame
      handleExit={handleExit}
      handleOnPrevious={handleOnPrevious}
      title={title}
      showProgressBar={showProgressBar}
      linearGradient={linearGradient}
      footer={footer}
      scrollResetKey={treeNav.current}
    >
      {children}
    </ContentFrame>
  );
};

export const ContentFrameTree = observer(_ContentFrameTree);
